module.exports = __webpack_public_path__ + "img/login.0657e6f7.png";